export default __webpack_public_path__ + "static/media/stas_maksin.5baa1770.png";